/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AvailabilityType = "BalanceAvailabilityAndFocus" | "MaximizeAvailability" | "MaximizeFocusTime" | "%future added value";
export type DataSourceProvider = "Google" | "Office365" | "%future added value";
export type DataSourceStatus = "Okay" | "RequiresReAuth" | "%future added value";
export type Day = "Friday" | "Monday" | "Saturday" | "Sunday" | "Thursday" | "Tuesday" | "Wednesday" | "%future added value";
export type EnforcementStateEnum = "ApproachingLimit" | "NoEnforcement" | "ReachedLimit" | "%future added value";
export type ExcludedSlots = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type MaxSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type MinSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type OrgCrawlTest = "GoogleApiAccessDisabled" | "GoogleContactSharingDisabled" | "NoCrawl" | "NoExternalOrganization" | "ShouldCrawl" | "Skipped" | "StartedCrawl" | "%future added value";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type UserStatusEnum = "Active" | "Preview" | "Restricted" | "%future added value";
export type WorkingHoursTypeEnum = "Base" | "Meeting" | "PreferredFocusTime" | "%future added value";
export type ChromeWrapper_viewer = {
    readonly user: {
        readonly id: string;
        readonly status: UserStatusEnum | null;
        readonly emails: ReadonlyArray<string>;
        readonly givenName: string | null;
        readonly familyName: string | null;
        readonly createdTime: unknown | null;
        readonly linkNameErrorable: {
            readonly message?: string | null | undefined;
            readonly statusCode?: number | null | undefined;
            readonly __typename: "LinkName";
            readonly linkName?: string | null | undefined;
        } | null;
        readonly schedulingLinks: ReadonlyArray<{
            readonly linkName: string;
            readonly linkUrl: string;
            readonly meetingSettings: {
                readonly id: string | null;
                readonly timingSettings: {
                    readonly durationMinutes: number;
                    readonly timeRange: {
                        readonly windowSizeDays: number | null;
                    };
                };
                readonly name: string;
                readonly slug: string;
                readonly isActive: boolean;
                readonly availabilityType: AvailabilityType;
            };
        }> | null;
        readonly members: ReadonlyArray<{
            readonly value: string | null;
            readonly scope: {
                readonly type: UrnType | null;
                readonly value: string | null;
            } | null;
        } | null> | null;
        readonly webAppFlagsErrorable: ({
            readonly __typename: "GraphEntityError";
            readonly statusCode: number | null;
            readonly message: string | null;
        } | {
            readonly __typename: "Flags";
            readonly flags: ReadonlyArray<string | null> | null;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null;
        readonly chromeExtensionFlagsErrorable: ({
            readonly __typename: "GraphEntityError";
            readonly statusCode: number | null;
            readonly message: string | null;
        } | {
            readonly __typename: "Flags";
            readonly flags: ReadonlyArray<string | null> | null;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null;
        readonly flowStates: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly flowKey: string | null;
                    readonly previousState: string | null;
                    readonly current: {
                        readonly state: string | null;
                        readonly percentComplete: number | null;
                        readonly errorMessage: string | null;
                    } | null;
                    readonly pending: {
                        readonly state: string | null;
                        readonly percentComplete: number | null;
                        readonly errorMessage: string | null;
                    } | null;
                    readonly " $fragmentRefs": FragmentRefs<"FastCrawlLoader_flowState" | "FlowStatePoller_flowState">;
                } | null;
            } | null> | null;
        } | null;
        readonly dataSources: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly state: DataSourceStatus | null;
                    readonly type: DataSourceProvider | null;
                    readonly name: string | null;
                } | null;
            } | null> | null;
        } | null;
        readonly orgs: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly domains: ReadonlyArray<string | null> | null;
                    readonly createdTime: unknown | null;
                    readonly crawlTest: OrgCrawlTest | null;
                    readonly featureGrid: {
                        readonly __typename: "FeatureGrid";
                        readonly stateMetadata: {
                            readonly userMetadata: {
                                readonly person: {
                                    readonly primaryCalendarId: string;
                                };
                                readonly trialMetadata: {
                                    readonly trialEndDate: string;
                                    readonly timeZone: string;
                                } | null;
                            } | null;
                        };
                    } | {
                        readonly __typename: "GraphEntityError";
                        readonly statusCode: number | null;
                        readonly message: string | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    };
                    readonly experiments: ReadonlyArray<string | null> | null;
                    readonly primaryOrgEmail: string;
                    readonly primaryOrgCalendar: string;
                    readonly userWorkingHours: {
                        readonly workingHours: {
                            readonly id: string;
                            readonly type: WorkingHoursTypeEnum | null;
                            readonly timeZone: string | null;
                            readonly daySettings: ReadonlyArray<{
                                readonly day: Day | null;
                                readonly setting: {
                                    readonly minSlot: MinSlot | null;
                                    readonly maxSlot: MaxSlot | null;
                                    readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
                                } | null;
                            } | null> | null;
                            readonly dayOverrides: ReadonlyArray<{
                                readonly date: string | null;
                                readonly setting: {
                                    readonly minSlot: MinSlot | null;
                                    readonly maxSlot: MaxSlot | null;
                                    readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
                                } | null;
                            } | null> | null;
                        } | null;
                    } | null;
                    readonly orgMeetingHours: {
                        readonly workingHours: {
                            readonly timeZone: string | null;
                        } | null;
                    } | null;
                    readonly shadowCalendarSettingsErrorable: {
                        readonly __typename: "ShadowCalendarSettings";
                        readonly enabled: boolean;
                        readonly shadowCalendarId: string | null;
                        readonly focusTimeIdealMinutesPerWeek: number;
                        readonly focusTimeSyncEnabled: boolean;
                        readonly focusTimeSyncAll: boolean;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    };
                    readonly flowStates: {
                        readonly edges: ReadonlyArray<{
                            readonly node: {
                                readonly id: string;
                                readonly flowKey: string | null;
                                readonly previousState: string | null;
                                readonly current: {
                                    readonly state: string | null;
                                    readonly percentComplete: number | null;
                                    readonly errorMessage: string | null;
                                } | null;
                                readonly pending: {
                                    readonly state: string | null;
                                    readonly percentComplete: number | null;
                                    readonly errorMessage: string | null;
                                } | null;
                                readonly " $fragmentRefs": FragmentRefs<"FastCrawlLoader_flowState" | "FlowStatePoller_flowState">;
                            } | null;
                        } | null> | null;
                    } | null;
                    readonly primaryTeam: ({
                        readonly __typename: "Team";
                        readonly teamId: string;
                        readonly teamName: string;
                    } | {
                        readonly __typename: "GraphEntityError";
                        readonly statusCode: number | null;
                        readonly message: string | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    }) | null;
                    readonly userTeams: {
                        readonly __typename: "TeamList";
                        readonly list: ReadonlyArray<{
                            readonly teamId: string;
                            readonly teamCalendarId: string | null;
                            readonly userSettings: {
                                readonly __typename: "TeamUserSettings";
                                readonly useTeamCalendar: boolean;
                            } | {
                                /*This will never be '%other', but we need some
                                value in case none of the concrete values match.*/
                                readonly __typename: "%other";
                            };
                            readonly settings: {
                                readonly __typename: "TeamSettings";
                                readonly manageTeamCalendar: boolean;
                            } | {
                                /*This will never be '%other', but we need some
                                value in case none of the concrete values match.*/
                                readonly __typename: "%other";
                            };
                        }>;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    };
                    readonly orgAccountingPeriod: {
                        readonly __typename: "OrgAccountingPeriod";
                        readonly periodRange: {
                            readonly minDate: string;
                            readonly maxDate: string;
                        };
                        readonly quotaMax: number;
                        readonly quotaUsed: number;
                        readonly enforcementState: EnforcementStateEnum;
                    } | {
                        readonly __typename: "GraphEntityError";
                        readonly statusCode: number | null;
                        readonly message: string | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    };
                    readonly userGoals: {
                        readonly edges: ReadonlyArray<{
                            readonly node: {
                                readonly id: string;
                                readonly goalId: string;
                                readonly name: string;
                                readonly isDeleted: boolean;
                                readonly options: {
                                    readonly specificOptions: {
                                        readonly minTimeSlot?: TimeSlot | null | undefined;
                                        readonly maxTimeSlot?: TimeSlot | null | undefined;
                                        readonly minimumDuration?: number | null | undefined;
                                        readonly idealDuration?: number | null | undefined;
                                        readonly maxMinutesPerBlock?: number | undefined;
                                    } | null;
                                } | null;
                            } | null;
                        } | null> | null;
                    } | null;
                    readonly eventColoringSettingsErrorable: {
                        readonly __typename: "GraphEntityError";
                        readonly statusCode: number | null;
                        readonly message: string | null;
                    } | {
                        readonly __typename: "EventColoringSettings";
                        readonly eventCategoryColorings: ReadonlyArray<{
                            readonly googleColorKey: string | null;
                            readonly eventCategory: string;
                            readonly active: boolean;
                            readonly isUserSet: boolean;
                            readonly " $fragmentRefs": FragmentRefs<"EventCategoryColoring_eventCategoryColoring">;
                        }> | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    };
                    readonly " $fragmentRefs": FragmentRefs<"OnboardingNUXRenderer_org" | "ChromePersonalCalendar_org" | "FastCrawlErrorCard_org" | "FeedScheduler_org" | "PricingDialog_org" | "FreemiumStatusCallout_org" | "ChromeCreateEvent_org" | "PlanStatusRefetch_org" | "EventColoringSettings_org">;
                } | null;
            } | null> | null;
        };
        readonly " $fragmentRefs": FragmentRefs<"ChromePersonalCalendar_user" | "TutorialBox_user" | "FeedScheduler_user">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"ChromeLogin_viewer" | "ChromeMenuDrawer_viewer">;
    readonly " $refType": "ChromeWrapper_viewer";
};
export type ChromeWrapper_viewer$data = ChromeWrapper_viewer;
export type ChromeWrapper_viewer$key = {
    readonly " $data"?: ChromeWrapper_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ChromeWrapper_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdTime",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "linkName",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v9 = {
        "kind": "InlineFragment",
        "selections": [
            (v3 /*: any*/),
            (v2 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v10 = [
        (v4 /*: any*/),
        (v9 /*: any*/),
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "flags",
                    "storageKey": null
                }
            ],
            "type": "Flags",
            "abstractKey": null
        } as any
    ], v11 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
    } as any, v13 = [
        (v12 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any
    ], v14 = {
        "alias": null,
        "args": (v11 /*: any*/),
        "concreteType": "FlowStateConnection",
        "kind": "LinkedField",
        "name": "flowStates",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "FlowStateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlowState",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "flowKey",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "previousState",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStatus",
                                "kind": "LinkedField",
                                "name": "current",
                                "plural": false,
                                "selections": (v13 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStatus",
                                "kind": "LinkedField",
                                "name": "pending",
                                "plural": false,
                                "selections": (v13 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "FastCrawlLoader_flowState"
                            },
                            {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "FlowStatePoller_flowState"
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "flowStates(first:1000000)"
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingSetting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedSlots",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "ChromeWrapper_viewer",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emails",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "givenName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "familyName",
                        "storageKey": null
                    },
                    (v1 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "linkNameErrorable",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    (v2 /*: any*/),
                                    (v3 /*: any*/)
                                ],
                                "type": "GraphEntityError",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    (v4 /*: any*/),
                                    (v5 /*: any*/)
                                ],
                                "type": "LinkName",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SchedulingLink",
                        "kind": "LinkedField",
                        "name": "schedulingLinks",
                        "plural": true,
                        "selections": [
                            (v5 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "linkUrl",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "MeetingSettings",
                                "kind": "LinkedField",
                                "name": "meetingSettings",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TimingSettings",
                                        "kind": "LinkedField",
                                        "name": "timingSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "durationMinutes",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "LinkTimeRange",
                                                "kind": "LinkedField",
                                                "name": "timeRange",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "windowSizeDays",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    (v6 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "slug",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isActive",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "availabilityType",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Urn",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": true,
                        "selections": [
                            (v7 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Urn",
                                "kind": "LinkedField",
                                "name": "scope",
                                "plural": false,
                                "selections": [
                                    (v8 /*: any*/),
                                    (v7 /*: any*/)
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "webAppFlagsErrorable",
                        "plural": false,
                        "selections": (v10 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "chromeExtensionFlagsErrorable",
                        "plural": false,
                        "selections": (v10 /*: any*/),
                        "storageKey": null
                    },
                    (v14 /*: any*/),
                    {
                        "alias": null,
                        "args": (v11 /*: any*/),
                        "concreteType": "DataSourceConnection",
                        "kind": "LinkedField",
                        "name": "dataSources",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DataSourceEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DataSource",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v12 /*: any*/),
                                            (v8 /*: any*/),
                                            (v6 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "dataSources(first:1000000)"
                    },
                    {
                        "alias": null,
                        "args": (v11 /*: any*/),
                        "concreteType": "OrgConnection",
                        "kind": "LinkedField",
                        "name": "orgs",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Org",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v6 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "domains",
                                                "storageKey": null
                                            },
                                            (v1 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "crawlTest",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "featureGrid",
                                                "plural": false,
                                                "selections": [
                                                    (v4 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "PaymentStateMetadata",
                                                                "kind": "LinkedField",
                                                                "name": "stateMetadata",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "UserMetadata",
                                                                        "kind": "LinkedField",
                                                                        "name": "userMetadata",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "OrgPerson",
                                                                                "kind": "LinkedField",
                                                                                "name": "person",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "kind": "ScalarField",
                                                                                        "name": "primaryCalendarId",
                                                                                        "storageKey": null
                                                                                    }
                                                                                ],
                                                                                "storageKey": null
                                                                            },
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "TrialMetadata",
                                                                                "kind": "LinkedField",
                                                                                "name": "trialMetadata",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "kind": "ScalarField",
                                                                                        "name": "trialEndDate",
                                                                                        "storageKey": null
                                                                                    },
                                                                                    (v15 /*: any*/)
                                                                                ],
                                                                                "storageKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "FeatureGrid",
                                                        "abstractKey": null
                                                    },
                                                    (v9 /*: any*/)
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "experiments",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "primaryOrgEmail",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "primaryOrgCalendar",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "resolveOverrides",
                                                        "value": false
                                                    }
                                                ],
                                                "concreteType": "UserWorkingHours",
                                                "kind": "LinkedField",
                                                "name": "userWorkingHours",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "WorkingHours",
                                                        "kind": "LinkedField",
                                                        "name": "workingHours",
                                                        "plural": false,
                                                        "selections": [
                                                            (v0 /*: any*/),
                                                            (v8 /*: any*/),
                                                            (v15 /*: any*/),
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "DaySetting",
                                                                "kind": "LinkedField",
                                                                "name": "daySettings",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "day",
                                                                        "storageKey": null
                                                                    },
                                                                    (v16 /*: any*/)
                                                                ],
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "DayOverride",
                                                                "kind": "LinkedField",
                                                                "name": "dayOverrides",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "date",
                                                                        "storageKey": null
                                                                    },
                                                                    (v16 /*: any*/)
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": "userWorkingHours(resolveOverrides:false)"
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "OrgMeetingHours",
                                                "kind": "LinkedField",
                                                "name": "orgMeetingHours",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "WorkingHours",
                                                        "kind": "LinkedField",
                                                        "name": "workingHours",
                                                        "plural": false,
                                                        "selections": [
                                                            (v15 /*: any*/)
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "shadowCalendarSettingsErrorable",
                                                "plural": false,
                                                "selections": [
                                                    (v4 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "enabled",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "shadowCalendarId",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "focusTimeIdealMinutesPerWeek",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "focusTimeSyncEnabled",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "focusTimeSyncAll",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "ShadowCalendarSettings",
                                                        "abstractKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            (v14 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "primaryTeam",
                                                "plural": false,
                                                "selections": [
                                                    (v4 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            (v17 /*: any*/),
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "teamName",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "Team",
                                                        "abstractKey": null
                                                    },
                                                    (v9 /*: any*/)
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "userTeams",
                                                "plural": false,
                                                "selections": [
                                                    (v4 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Team",
                                                                "kind": "LinkedField",
                                                                "name": "list",
                                                                "plural": true,
                                                                "selections": [
                                                                    (v17 /*: any*/),
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "teamCalendarId",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": null,
                                                                        "kind": "LinkedField",
                                                                        "name": "userSettings",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            (v4 /*: any*/),
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "kind": "ScalarField",
                                                                                        "name": "useTeamCalendar",
                                                                                        "storageKey": null
                                                                                    }
                                                                                ],
                                                                                "type": "TeamUserSettings",
                                                                                "abstractKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": null,
                                                                        "kind": "LinkedField",
                                                                        "name": "settings",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            (v4 /*: any*/),
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "kind": "ScalarField",
                                                                                        "name": "manageTeamCalendar",
                                                                                        "storageKey": null
                                                                                    }
                                                                                ],
                                                                                "type": "TeamSettings",
                                                                                "abstractKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "TeamList",
                                                        "abstractKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "orgAccountingPeriod",
                                                "plural": false,
                                                "selections": [
                                                    (v4 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "DateRange",
                                                                "kind": "LinkedField",
                                                                "name": "periodRange",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "minDate",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "maxDate",
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "quotaMax",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "quotaUsed",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "enforcementState",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "OrgAccountingPeriod",
                                                        "abstractKey": null
                                                    },
                                                    (v9 /*: any*/)
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": (v11 /*: any*/),
                                                "concreteType": "GoalConnection",
                                                "kind": "LinkedField",
                                                "name": "userGoals",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "GoalEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Goal",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    (v0 /*: any*/),
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "goalId",
                                                                        "storageKey": null
                                                                    },
                                                                    (v6 /*: any*/),
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "isDeleted",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "GoalOptions",
                                                                        "kind": "LinkedField",
                                                                        "name": "options",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": null,
                                                                                "kind": "LinkedField",
                                                                                "name": "specificOptions",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "kind": "ScalarField",
                                                                                                "name": "minTimeSlot",
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "kind": "ScalarField",
                                                                                                "name": "maxTimeSlot",
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "kind": "ScalarField",
                                                                                                "name": "minimumDuration",
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "kind": "ScalarField",
                                                                                                "name": "idealDuration",
                                                                                                "storageKey": null
                                                                                            }
                                                                                        ],
                                                                                        "type": "GoalWithinDayOptions",
                                                                                        "abstractKey": null
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "kind": "ScalarField",
                                                                                                "name": "maxMinutesPerBlock",
                                                                                                "storageKey": null
                                                                                            }
                                                                                        ],
                                                                                        "type": "GoalWithinWeekOptions",
                                                                                        "abstractKey": null
                                                                                    }
                                                                                ],
                                                                                "storageKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": "userGoals(first:1000000)"
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "eventColoringSettingsErrorable",
                                                "plural": false,
                                                "selections": [
                                                    (v4 /*: any*/),
                                                    (v9 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "EventCategoryColoring",
                                                                "kind": "LinkedField",
                                                                "name": "eventCategoryColorings",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "googleColorKey",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "eventCategory",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "active",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "isUserSet",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "args": null,
                                                                        "kind": "FragmentSpread",
                                                                        "name": "EventCategoryColoring_eventCategoryColoring"
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "EventColoringSettings",
                                                        "abstractKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "OnboardingNUXRenderer_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "ChromePersonalCalendar_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "FastCrawlErrorCard_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "FeedScheduler_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "PricingDialog_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "FreemiumStatusCallout_org"
                                            },
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "calendarIds",
                                                        "value": []
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "ChromeCreateEvent_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "PlanStatusRefetch_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "EventColoringSettings_org"
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "orgs(first:1000000)"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ChromePersonalCalendar_user"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TutorialBox_user"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "FeedScheduler_user"
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ChromeLogin_viewer"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ChromeMenuDrawer_viewer"
            }
        ],
        "type": "Viewer",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'b462b69b6b797eef722a231b8b444daf';
export default node;
